import { render, staticRenderFns } from "./AuditMsg.vue?vue&type=template&id=521a1049&scoped=true&"
import script from "./AuditMsg.vue?vue&type=script&lang=js&"
export * from "./AuditMsg.vue?vue&type=script&lang=js&"
import style0 from "./AuditMsg.vue?vue&type=style&index=0&id=521a1049&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521a1049",
  null
  
)

export default component.exports